import React, { useEffect, useRef, useState } from 'react'
import "./visit-history.scss"
import { useDispatch, useSelector } from 'react-redux';
import { getAllVisit } from '../../../store/slices/visitSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCapsules, faComment, faFilePen, faPills, faSave, faTrash } from '@fortawesome/free-solid-svg-icons';
import { post, put } from '../../../utils/fetchAPI';
import { showErrorToast, showSuccessToast } from '../../../utils/toaster-alert';
import { formatDate, provisionalDxTitle } from '../../../utils/common-funtions/common';
import { ToolTip } from '../../common/tooltip/tooltip';
import CustomModal from '../../common/modal/modal';
import { prescriptionUpdateSubDocument } from '../../../service/api/prescription';
import { toast } from 'react-toastify';

const VisitHistory = ({ setSelectedOption, patientId, visitDetails, updateState }) => {
    const { selectedRole } = useSelector((state) => state.auth);
    let { visits, isVisitLoading } = useSelector(
        (state) => state.visit
    );
    const [showAddRemarks, setShowAddRemarks] = useState(false)
    const [currentVisit, setCurrentVisit] = useState({})
    const [selectedTest, setSelectedTest] = useState({})
    const [isLoding, setIsLoding] = useState(false)

    var lab = useRef()

    const dispatch = useDispatch()
    useEffect(() => {
        if (visitDetails?.patient || patientId)
            dispatch(getAllVisit(visitDetails?.patient || patientId))
    }, [visitDetails])

    const previousMedicineAdd = async (previousVisitId) => {
        // /visit/add-prev-med/:visitId
        setIsLoding(true)
        await post(`visit/add-prev-med/${visitDetails?._id}`, { prevVisitId: previousVisitId })
            .then((res) => {
                if (res.status == 200) {
                    if (res?.data?.errors) {
                        showErrorToast(res?.data?.errors[0]?.msg)
                    } else {
                        showSuccessToast("Previous visit medicine added to current prescription")
                        updateState(res?.data)
                        setSelectedOption({ id: 4, name: "Prescription" },)
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => { setIsLoding(false) })
        setIsLoding(false)
    }


    const setRemarksFun = async (data = {}) => {
        let payLoad = {}
        payLoad._id = data?._id || selectedTest?._id
        payLoad[`labTests.$.findings`] = data?.findings || selectedTest?.findings
        await prescriptionUpdateSubDocument("labTests", payLoad, currentVisit?._id).
            then((res) => {
                if (res.status == 200) {
                    if (visitDetails?.patient || patientId)
                        dispatch(getAllVisit(visitDetails?.patient || patientId))
                    setShowAddRemarks(false)
                    setCurrentVisit({})
                    setSelectedTest({})
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally()
    }


    const saveinvestigationReportsFun = async (labTests, id) => {
        await put(`/visit/${id}`, { investigationReports: labTests })
            .then((res) => {
                if (res.status === 200) {
                    if (visitDetails?.patient || patientId)
                        dispatch(getAllVisit(visitDetails?.patient || patientId))
                    if (labTests?.length > 0) {
                        updateState(res?.data)
                        toast.success("Successfully set as investigation report")
                    }
                    else {
                        if (id == visitDetails?._id) {
                            updateState(res?.data)
                        }
                        toast.error("Investigation report deleted")
                    }
                }
            })
            .catch((e) => { })
            .finally(() => { })
    }

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Enter" && e.shiftKey) {
                e.preventDefault();
                setRemarksFun(lab.current)
            }
        };

        if (showAddRemarks == true)
            document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [showAddRemarks]);


    return (
        <div className='visit-history'>
            {visits && visits?.map((visit, index) => {
                let reasonForVist = visit?.reasonForVisit?.trim()?.split('\n') || []
                let historyOfPresetIllness = visit?.historyOfPresetIllness?.trim()?.split('\n') || []
                let currentMedication = visit?.currentMedication?.trim()?.split('\n') || []
                let extraNote = visit?.extraNote?.trim()?.split('\n') || []
                let provisionalDx = visit?.provisionalDx?.trim()?.split('\n') || []
                let differentialDx = visit?.differentialDx?.trim()?.split('\n') || []
                return (
                    <div key={index} className='individual-visit-history'>
                        <div className='history-header d-flex justify-content-between'>
                            <label>Date: {visit?.appointmentDate ? formatDate(visit?.appointmentDate?.slice(0, 10)) : formatDate(visit?.createdAt?.slice(0, 10))}  {(visit?._id == visitDetails?._id) && <span className='mx-2 text-info fw-bolder'>Current visit</span>}</label>
                            <button disabled={isLoding || false} onClick={() => { previousMedicineAdd(visit?._id) }} style={{ fontSize: "13px", fontWeight: "600" }} className='btn btn-success w-100 py-0 my-0'>Use this Rx for current visit <FontAwesomeIcon className="mt-0 pt-0" icon={faCapsules} /></button>
                        </div>
                        <div className='row'>
                            <div className='col-md-6 pt-1 border-right'>
                                <span className='d-block ml-1'>Attending: <strong>{visit?.doctorName}</strong></span>
                                <div>

                                </div>
                                <div className=''>
                                    {reasonForVist?.length > 0 && reasonForVist[0]?.length > 0 && <p className='title'>Reason for visit: </p>}
                                    {reasonForVist?.length > 0 && reasonForVist[0]?.length > 0 && <div className="px-2 mb-0">
                                        {
                                            reasonForVist?.map((reason, index) => {
                                                return (<p style={{ fontSize: "13px" }} className='my-0' key={index}><span>&#8226;</span> {reason}</p>)
                                            })
                                        }
                                    </div>}
                                </div>
                                <div className=''>
                                    {historyOfPresetIllness?.length > 0 && historyOfPresetIllness[0]?.length > 0 && <p className='title'>History of preset illness: </p>}
                                    {historyOfPresetIllness?.length > 0 && historyOfPresetIllness[0]?.length > 0 && <div className="px-2 mb-0">
                                        {
                                            historyOfPresetIllness?.map((data, index) => {
                                                return (<p style={{ fontSize: "13px" }} className='my-0' key={index}><span>&#8226;</span> {data}</p>)
                                            })
                                        }
                                    </div>}
                                </div>
                                <div className=''>
                                    {/* Per-visit free text only. The structured list lives on the
                                        patient, so it is not part of any one visit's history. */}
                                    {currentMedication?.length > 0 && currentMedication[0]?.length > 0 && <p className='title'>Current Medication: </p>}
                                    {currentMedication?.length > 0 && currentMedication[0]?.length > 0 && <div className="px-2 mb-0">
                                        {
                                            currentMedication?.map((data, index) => {
                                                return (<p style={{ fontSize: "13px" }} className='my-0' key={index}><span>&#8226;</span> {data}</p>)
                                            })
                                        }
                                    </div>}
                                </div>
                                <div className=''>
                                    {extraNote?.length > 0 && extraNote[0]?.length > 0 && <p className='title'>Note:</p>}
                                    {extraNote?.length > 0 && extraNote[0]?.length > 0 && <div className="px-2 mb-0">
                                        {
                                            extraNote?.map((data, index) => {
                                                return (<p style={{ fontSize: "13px" }} className='my-0' key={index}><span>&#8226;</span> {data}</p>)
                                            })
                                        }
                                    </div>}
                                </div>
                                {
                                    visit?.vitals &&
                                    <div className=''>
                                        <div className=''>
                                            <span className='title'>Vital signs</span>
                                            <div className='d-flex flex-wrap px-1' style={{ fontSize: "13px" }}>
                                                {visit?.vitals?.height > 0 && <p className='mr-2 mb-1'><span
                                                    className=''>H: </span>{visit?.vitals?.height + "ft" || " "}
                                                </p>}
                                                {visit?.vitals?.weight > 0 && <p className='mr-2 mb-1'><span
                                                    className=''>W: </span>{visit?.vitals?.weight + "kg" || " "}
                                                </p>}
                                                {visit?.vitals?.bmi > 0 && <p className='mb-1 mr-2'><span
                                                    className=''>BMI: </span>{visit?.vitals?.bmi || " "}</p>}
                                                {visit?.vitals?.bp?.length > 1 && <p className='mb-1 mr-2'><span
                                                    className=''>BP: </span>{visit?.vitals?.bp || " "} mmHg</p>}
                                                {visit?.vitals?.temperature && <p className='mb-1 mr-2'><span
                                                    className=''>Temp: </span>{visit?.vitals?.temperature + "°F" || " "}
                                                </p>}
                                                {visit?.vitals?.rr && <p className='mb-1 mr-2'><span
                                                    className=''>RR: </span>{visit?.vitals?.rr + "/min" || " "}
                                                </p>}
                                                {visit?.vitals?.spo2 && <p className='mb-1 mr-2'><span
                                                    className=''>SPO2: </span>{visit?.vitals?.spo2 + "%" || " "}
                                                </p>}
                                                {visit?.vitals?.hr && <p className='mb-1 mr-2'><span
                                                    className=''>HR: </span>{visit?.vitals?.hr + "/min" || " "}
                                                </p>}
                                                {visit?.vitals?.note && <p className='mb-1'><span
                                                    className=''>Note: </span>{visit?.vitals?.note}
                                                </p>}

                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className=''>
                                    {provisionalDx?.length > 0 && provisionalDx[0]?.length > 0 && <p className='title'>{provisionalDxTitle(selectedRole)}:  </p>}
                                    {provisionalDx?.length > 0 && provisionalDx[0]?.length > 0 && <div className="px-2 mb-0">
                                        {
                                            provisionalDx?.map((data, index) => {
                                                return (<p style={{ fontSize: "13px" }} className='my-0' key={index}><span>&#8226;</span> {data}</p>)
                                            })
                                        }
                                    </div>}
                                </div>
                                <div className=''>
                                    {differentialDx?.length > 0 && differentialDx[0]?.length > 0 && <p className='title'> Differential Diagnosis:</p>}
                                    {differentialDx?.length > 0 && differentialDx[0]?.length > 0 && <div className="px-2 mb-0">
                                        {
                                            differentialDx?.map((data, index) => {
                                                return (<p style={{ fontSize: "13px" }} className='my-0' key={index}><span>&#8226;</span> {data}</p>)
                                            })
                                        }
                                    </div>}
                                </div>

                                <div className=''>
                                    {visit?.advices?.length > 0 && <p className='title'>Advices:</p>}
                                    {visit?.advices?.map((advice, index) => {
                                        let adviceArray = advice?.details?.trim().split('\n') || []
                                        return (
                                            adviceArray?.map((data, index) => {
                                                return (
                                                    <p key={"advice" + index} className='option my-0 pb-1 ml-2' style={{ fontSize: "13px" }}>
                                                        &#8226; {data}
                                                    </p>
                                                )
                                            })
                                        )

                                    })}
                                </div>

                                <div className='mb-0'>
                                    {visit?.carePlan?.details?.length > 0 && <p className='title'>Care Plan: <span className='content' dangerouslySetInnerHTML={{ __html: visit?.carePlan?.details }}></span></p>}
                                </div>
                            </div>
                            {/* <>{console.log(visit?.prescriptions?.medicines,"check")}</> */}
                            <div className='col-md-6'>
                                {visit?.medicines?.length > 0 && <small className='title mx-0 px-0 border-bottom'>Medicine list</small>}
                                {
                                    visit?.medicines?.map((medicine, i) => {
                                        return <div key={i} className='d-flex'>
                                            <small>  <FontAwesomeIcon size='xs' className='mt-1 p-0 m-0 mb-2' icon={faPills} /></small>
                                            <small key={index} className=' px-1' style={{ fontSize: "14px", fontStyle: "italic", color: "#088aab" }}>{medicine?.name}</small>
                                            <small key={index} className='px-1' style={{ fontSize: "12px", fontStyle: "italic" }}> {medicine?.sig}</small>
                                            <small key={index} className='px-1' style={{ fontSize: "12px", fontStyle: "italic" }}> ( {medicine?.duration} )</small>
                                        </div>
                                    })
                                }
                                <div>
                                    <div>
                                        {visit?.labTests?.length > 0 && <p className='title d-inline-block mb-2 mx-0 px-0 border-bottom'>Investigation</p>}

                                        {visit?.labTests?.length > 0 && <p onClick={() => { saveinvestigationReportsFun(visit?.labTests, visitDetails?._id) }} className='d-inline-block'>
                                            <ToolTip text={"Save as investigation Reports"}>
                                                <p className="px-2 mx-2 mr-3 complete-btn rounded bg-info"> <FontAwesomeIcon fontSize={"13px"} className="mt-0 pt-0" icon={faSave} /></p>
                                            </ToolTip>
                                        </p>}


                                    </div>
                                    {visit?.labTests?.map((labTest, index) => {
                                        return (
                                            <div className='mb-1'>
                                                <div className='d-flex py-0 my-0'>
                                                    <p style={{ fontSize: "13px" }} className='d-block option my-0 pb-1'>
                                                        {index + 1}. {labTest?.name}
                                                    </p>
                                                    <p className='my-0 py-0' onClick={() => {
                                                        setShowAddRemarks(true)
                                                        setCurrentVisit(visit)
                                                        setSelectedTest(labTest)
                                                    }}>
                                                        <ToolTip text={labTest?.findings ? "Update findings" : "Add findings"} >
                                                            <span style={{ color: "#0CAB81" }} className=""><FontAwesomeIcon size='xs' className='ml-2 mb-1' icon={faFilePen} /></span>
                                                        </ToolTip>
                                                    </p>
                                                </div>
                                                {labTest?.findings?.length > 0 && <p style={{ fontSize: "13px" }} className='pl-2 py-0 my-0'>- {labTest?.findings}</p>}
                                            </div>
                                        )
                                    })}
                                </div>
                                <div>
                                    <div>
                                        {visit?.investigationReports?.length > 0 && <p className='title d-inline-block mb-2 mx-0 px-0 border-bottom'>Investigation Reports</p>}
                                        {visit?.investigationReports?.length > 0 && <p onClick={() => { saveinvestigationReportsFun([], visit?._id) }} className='d-inline-block'>
                                            <ToolTip text={"Delete investigation Reports"}>
                                                <p className="px-2 mx-2 mr-3 complete-btn rounded text-danger"> <FontAwesomeIcon fontSize={"13px"} className="mt-0 pt-0" icon={faTrash} /></p>
                                            </ToolTip>
                                        </p>}
                                    </div>
                                    {visit?.investigationReports?.map((labTest, index) => {
                                        if (labTest?.findings?.length > 0)
                                            return (
                                                <div className='mb-1'>
                                                    <div className='d-flex py-0 my-0'>
                                                        <p style={{ fontSize: "13px" }} className='d-block option my-0 pb-1'>
                                                            {index + 1}. {labTest?.name}
                                                        </p>
                                                        <p className='my-0 py-0' onClick={() => {
                                                            setShowAddRemarks(true)
                                                            setCurrentVisit(visit)
                                                            setSelectedTest(labTest)
                                                        }}>
                                                        </p>
                                                    </div>
                                                    {labTest?.findings?.length > 0 && <p style={{ fontSize: "13px", fontStyle: "italic" }} className='pl-2 py-0 my-0'>- {labTest?.findings}</p>}
                                                </div>
                                            )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}


            <CustomModal
                size="sm"
                show={showAddRemarks}
                isHeaderHide={true}
            // setShow={setShow}
            >
                <div className='mt-0  create-template px-2 py-2'>
                    <label className='mt-0 pt-0 d-block'>Remakrs for - {selectedTest?.name}</label>
                    <textarea
                        style={{ fontSize: "13px" }}
                        className="form-control px-1 w-100"
                        autoComplete="off"
                        type="text"
                        rows={2}
                        placeholder="findings"
                        value={selectedTest?.findings}
                        onChange={(e) => {
                            lab.current = { ...selectedTest, findings: e.target.value }
                            setSelectedTest({ ...selectedTest, findings: e.target.value })
                        }}
                    />
                    <div className='text-center mt-2'>
                        <button onClick={() => {
                            setRemarksFun()
                        }} className='btn py-0 mr-1'>Set <small>(shit+enter)</small>
                        </button>
                        <button onClick={() => setShowAddRemarks(!showAddRemarks)} className='btn py-0'>Cancel</button>
                    </div>
                </div>
            </CustomModal>

        </div>
    )
}

export default VisitHistory
